/**
 * Constantes do módulo de autenticação.
 *
 * As chaves de cookie mantêm o prefixo `ttz.ra-auth.` herdado do react-admin:
 * renomeá-las invalidaria o preenchimento automático de quem já tem o cookie
 * gravado, sem ganho nenhum.
 */

export const AUTH_ACTIONS = [
  'sign-in',
  'sign-up',
  'forgot-password',
  'reset-password',
  'confirmation',
  'resend-confirmation'
] as const

export type AuthAction = (typeof AUTH_ACTIONS)[number]

export const EMAIL_COOKIE_KEY = 'ttz.ra-auth.e'
export const PASSWORD_COOKIE_KEY = 'ttz.ra-auth.p'

/** Provedores sociais habilitados. Facebook saiu do servidor e da interface. */
export const ENABLED_PROVIDERS = ['google', 'apple'] as const

export type EnabledProvider = (typeof ENABLED_PROVIDERS)[number]
